import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import VueDraggableResizable from '@/components/common/vue-draggable-resizable.vue';
import '@/assets/css/vue-draggable-resizable.css';
import { mapState } from 'vuex';
export default {
  props: {
    initLogoList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    firstLogoList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  components: {
    VueDraggableResizable
  },
  data() {
    return {
      logoList: [],
      isAppliedImg: true,
      setInitLogos: [],
      saveLogoAreaInfo: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      showUploadLog: state => state.showUploadLogo
    }),
    returnClass() {
      return this.showUploadLog ? 'noBorder' : '';
    }
  },
  watch: {
    initLogoList(newVal) {
      this.logoList = newVal;
    },
    firstLogoList(newVal) {
      this.$nextTick(() => {
        this.setInitLogos = newVal;
      });
    }
  },
  created() {
    Bus.$on('setLogo', (isSelect, info) => {
      if (isSelect) {
        const obj = {};
        obj.name = info.name;
        obj.url = info.url;
        obj.active = true;
        obj.realWidth = info.realWidth;
        obj.realHeight = info.realHeight;
        obj.width = info.width;
        obj.height = info.height;
        obj.id = info.id;
        obj.isAdd = true;
        this.logoList.push(obj);
      } else {
        this.logoList.forEach((item, index) => {
          if (item.name === info.name) {
            this.logoList.splice(index, 1);
          }
        });
      }
    });
    Bus.$on('setLogos', v => {
      // 为了最开始一个 logo 也没有时无法获取 logo 区域的宽和高特殊处理
      let timer = 0;
      if (!this.logoList.length && !this.setInitLogos.length) {
        timer = 50;
        this.$emit('callBack', v);
      }
      setTimeout(() => {
        v.logos.forEach((item, index) => {
          const {
            realX,
            realY,
            realWidth,
            realHeight
          } = this.calculatorWidthHeight(item, 'resume');
          item.realX = realX;
          item.realY = realY;
          item.realWidth = realWidth;
          item.realHeight = realHeight;
          this.$set(v.logos, index, item);
        });
        this.$emit('callBack', v);
      }, timer);
    });
  },
  mounted() {
    this.resizeLogoArea('init');
  },
  methods: {
    resizeLogoArea(init) {
      // 先根据屏幕的大小动态计算屏幕的宽高
      // 首先根据文档的高减去头部，底部，output区域的高为可使用区域(大概减210px)，暂定可用区域的90%作为高度
      const logoAreaHeight = (document.body.clientHeight - 210) * 0.9;
      // 因为 R 那边的 logo 区域是 150*1080 所以需要根据比例来计算 web 端的宽
      const logoAreaWidth = parseInt(15 * logoAreaHeight / 108);
      this.$refs.logoRef.style.width = logoAreaWidth + 'px';
      this.$refs.logoRef.style.height = logoAreaHeight + 'px';
      this.State.kioskSideBarInfo.width = logoAreaWidth;
      this.State.kioskSideBarInfo.height = logoAreaHeight;
      //  如果不是初始化时的变动需要改变 logo 大小
      if (!init) {
        this.saveLogoAreaInfo.width = logoAreaWidth;
        this.saveLogoAreaInfo.height = logoAreaHeight;
      } else {
        this.saveLogoAreaInfo.width = logoAreaWidth;
        this.saveLogoAreaInfo.height = logoAreaHeight;
      }
    },
    changeLogoList(list) {
      this.setInitLogos = JSON.parse(JSON.stringify(list));
    },
    changePicStatus(type) {
      if (type === 'back') {
        this.isAppliedImg = true;
      } else if (type === 'setPicture') {
        this.isAppliedImg = false;
      }
    },
    onDrag(x, y, item) {
      item.realX = x;
      item.realY = y;
      Bus.$emit('changeHadSelectInfo', item);
    },
    onResize(x, y, width, height, item) {
      item.realX = x;
      item.realY = y;
      item.realWidth = width;
      item.realHeight = height;
      Bus.$emit('changeHadSelectInfo', item);
    },
    // 因为发送到R的数据需要是按照1920：1080的比例所以需要计算
    calculatorWidthHeight(logoInfo, type) {
      let {
        realX,
        realY,
        realWidth,
        realHeight
      } = logoInfo;
      const logoAreaWidth = this.$refs.logoRef.clientWidth;
      const logoAreaHeight = this.$refs.logoRef.clientHeight;
      if (type === 'send') {
        realX = Number((realX / logoAreaWidth * 100).toFixed(2));
        realY = Number((realY / logoAreaHeight * 100).toFixed(2));
        realWidth = Number((realWidth / logoAreaWidth * 100).toFixed(2));
        realHeight = Number((realHeight / logoAreaHeight * 100).toFixed(2));
      } else {
        realX = Number((realX * logoAreaWidth / 100).toFixed(0));
        realY = Number((realY * logoAreaHeight / 100).toFixed(0));
        realWidth = Number((realWidth * logoAreaWidth / 100).toFixed(0));
        realHeight = Number((realHeight * logoAreaHeight / 100).toFixed(0));
      }
      return {
        realX,
        realY,
        realWidth,
        realHeight
      };
    }
  }
};